import isNaN from 'lodash/isNaN';
import { EMPTY_DASH } from '../../constants';

/*
 * @deprecated использовать функцию {format} from @/share/lib/string
 */
export function formatDate<I = string>(
    str: number | string | undefined | null,
    options: {
        format?: Intl.DateTimeFormatOptions;
        locale?: string;
        invalidValue?: I;
    } = {}
): I | string {
    const {
        format = { month: '2-digit', day: '2-digit', year: 'numeric' },
        locale = 'ru',
        invalidValue = EMPTY_DASH,
    } = options;

    if (typeof str === 'undefined' || str === null) {
        return invalidValue;
    }

    const date = new Date(str);

    if (isNaN(date.getTime())) {
        return invalidValue;
    }

    const formatter = new Intl.DateTimeFormat(locale, format);

    return formatter.format(date);
}
